/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.LoginOutMsg = (function() {

    /**
     * Properties of a LoginOutMsg.
     * @exports ILoginOutMsg
     * @interface ILoginOutMsg
     * @property {string|null} [guid] LoginOutMsg guid
     * @property {number|null} [version] LoginOutMsg version
     * @property {string|null} [fromGuid] LoginOutMsg fromGuid
     * @property {LoginOutMsg.Role|null} [role] LoginOutMsg role
     */

    /**
     * Constructs a new LoginOutMsg.
     * @exports LoginOutMsg
     * @classdesc Represents a LoginOutMsg.
     * @implements ILoginOutMsg
     * @constructor
     * @param {ILoginOutMsg=} [properties] Properties to set
     */
    function LoginOutMsg(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * LoginOutMsg guid.
     * @member {string} guid
     * @memberof LoginOutMsg
     * @instance
     */
    LoginOutMsg.prototype.guid = "";

    /**
     * LoginOutMsg version.
     * @member {number} version
     * @memberof LoginOutMsg
     * @instance
     */
    LoginOutMsg.prototype.version = 0;

    /**
     * LoginOutMsg fromGuid.
     * @member {string} fromGuid
     * @memberof LoginOutMsg
     * @instance
     */
    LoginOutMsg.prototype.fromGuid = "";

    /**
     * LoginOutMsg role.
     * @member {LoginOutMsg.Role} role
     * @memberof LoginOutMsg
     * @instance
     */
    LoginOutMsg.prototype.role = 0;

    /**
     * Creates a new LoginOutMsg instance using the specified properties.
     * @function create
     * @memberof LoginOutMsg
     * @static
     * @param {ILoginOutMsg=} [properties] Properties to set
     * @returns {LoginOutMsg} LoginOutMsg instance
     */
    LoginOutMsg.create = function create(properties) {
        return new LoginOutMsg(properties);
    };

    /**
     * Encodes the specified LoginOutMsg message. Does not implicitly {@link LoginOutMsg.verify|verify} messages.
     * @function encode
     * @memberof LoginOutMsg
     * @static
     * @param {ILoginOutMsg} message LoginOutMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LoginOutMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.guid != null && Object.hasOwnProperty.call(message, "guid"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.guid);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.version);
        if (message.fromGuid != null && Object.hasOwnProperty.call(message, "fromGuid"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.fromGuid);
        if (message.role != null && Object.hasOwnProperty.call(message, "role"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.role);
        return writer;
    };

    /**
     * Encodes the specified LoginOutMsg message, length delimited. Does not implicitly {@link LoginOutMsg.verify|verify} messages.
     * @function encodeDelimited
     * @memberof LoginOutMsg
     * @static
     * @param {ILoginOutMsg} message LoginOutMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    LoginOutMsg.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a LoginOutMsg message from the specified reader or buffer.
     * @function decode
     * @memberof LoginOutMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {LoginOutMsg} LoginOutMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LoginOutMsg.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.LoginOutMsg();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.guid = reader.string();
                break;
            case 2:
                message.version = reader.int32();
                break;
            case 3:
                message.fromGuid = reader.string();
                break;
            case 4:
                message.role = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a LoginOutMsg message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof LoginOutMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {LoginOutMsg} LoginOutMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    LoginOutMsg.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a LoginOutMsg message.
     * @function verify
     * @memberof LoginOutMsg
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    LoginOutMsg.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.guid != null && message.hasOwnProperty("guid"))
            if (!$util.isString(message.guid))
                return "guid: string expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            if (!$util.isString(message.fromGuid))
                return "fromGuid: string expected";
        if (message.role != null && message.hasOwnProperty("role"))
            switch (message.role) {
            default:
                return "role: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        return null;
    };

    /**
     * Creates a LoginOutMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof LoginOutMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {LoginOutMsg} LoginOutMsg
     */
    LoginOutMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.LoginOutMsg)
            return object;
        var message = new $root.LoginOutMsg();
        if (object.guid != null)
            message.guid = String(object.guid);
        if (object.version != null)
            message.version = object.version | 0;
        if (object.fromGuid != null)
            message.fromGuid = String(object.fromGuid);
        switch (object.role) {
        case "UNKNOWN":
        case 0:
            message.role = 0;
            break;
        case "AGENT":
        case 1:
            message.role = 1;
            break;
        case "CUSTOMER":
        case 2:
            message.role = 2;
            break;
        case "CUSTOMER_MINI":
        case 3:
            message.role = 3;
            break;
        case "CUSTOMER_CLIENT":
        case 4:
            message.role = 4;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a LoginOutMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof LoginOutMsg
     * @static
     * @param {LoginOutMsg} message LoginOutMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    LoginOutMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.guid = "";
            object.version = 0;
            object.fromGuid = "";
            object.role = options.enums === String ? "UNKNOWN" : 0;
        }
        if (message.guid != null && message.hasOwnProperty("guid"))
            object.guid = message.guid;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            object.fromGuid = message.fromGuid;
        if (message.role != null && message.hasOwnProperty("role"))
            object.role = options.enums === String ? $root.LoginOutMsg.Role[message.role] : message.role;
        return object;
    };

    /**
     * Converts this LoginOutMsg to JSON.
     * @function toJSON
     * @memberof LoginOutMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    LoginOutMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * Role enum.
     * @name LoginOutMsg.Role
     * @enum {number}
     * @property {number} UNKNOWN=0 UNKNOWN value
     * @property {number} AGENT=1 AGENT value
     * @property {number} CUSTOMER=2 CUSTOMER value
     * @property {number} CUSTOMER_MINI=3 CUSTOMER_MINI value
     * @property {number} CUSTOMER_CLIENT=4 CUSTOMER_CLIENT value
     */
    LoginOutMsg.Role = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN"] = 0;
        values[valuesById[1] = "AGENT"] = 1;
        values[valuesById[2] = "CUSTOMER"] = 2;
        values[valuesById[3] = "CUSTOMER_MINI"] = 3;
        values[valuesById[4] = "CUSTOMER_CLIENT"] = 4;
        return values;
    })();

    return LoginOutMsg;
})();

module.exports = $root;
